
import tippy from 'tippy.js';
import Base from './base';

class Tooltip extends Base {
	start() {
		const { tooltipText, tooltipPlacement } = this.options;

		if (!tooltipText) {
			throw new Error('No tooltip text');
		}

		return this.createTooltip(tooltipText, tooltipPlacement);
	}

	createTooltip(content, placement = 'bottom') {
		return tippy(this.el, {
			boundary: 'viewport',
			content,
			hideOnClick: false,
			maxWidth: 240,
			placement,

			delay: [50, 50],
			duration: 100,
			onShow(instance) {
				instance.setContent(instance.reference.dataset.optionTooltipText);
			},
		});
	}
}

export default Tooltip;
